// Motivo de rechazo legible para un comprobante ARCA — compartido entre el
// historial (Payments/ArcaInvoices.js) y el modal de emisión
// (Events/Agenda/Event/Facturar.js). Antes cada uno tenía su propia versión:
// el modal solo sabía traducir RECEPTOR_REQUERIDO_RG4444 (con un hint
// accionable aparte) y mostraba en blanco cualquier otro código clasificado
// (CUIT_NOT_DELEGATED, PUNTO_VENTA_NO_RECE, RETRIES_EXHAUSTED) — justo el
// primer lugar donde el profesional ve el rechazo, sin ninguna pista de qué
// pasó ni qué hacer.
//
// Motivos con código conocido (tasks.js TERMINAL_CODES + el salvoconducto de
// reintentos agotados).
export const REJECTION_LABEL = {
  RETRIES_EXHAUSTED: 'ARCA no respondió tras varios intentos. Contactá a soporte para reintentar.',
  CUIT_NOT_DELEGATED: 'Se detectó que la delegación del servicio a DrApp fue revocada en ARCA.',
  PUNTO_VENTA_NO_RECE: 'El punto de venta no está habilitado para facturación electrónica (Web Services).',
  RECEPTOR_REQUERIDO_RG4444: 'Falta el documento del receptor, obligatorio para este monto (RG 4444).',
}

export const rejectionReason = invoice => {
  if (invoice.status !== 'rejected') return null
  if (invoice.error?.code && REJECTION_LABEL[invoice.error.code]) return REJECTION_LABEL[invoice.error.code]
  // observaciones puede venir con items sin msg utilizable (ej. un Obs de
  // ARCA con Code pero sin Msg) — sin este chequeo, .join(' — ') sobre puros
  // vacíos da '' y esa cadena vacía se devolvía tal cual, perdiendo para
  // siempre un error.message real que sí tenía algo útil para mostrar.
  const fromObservaciones = invoice.observaciones?.length
    ? invoice.observaciones.map(o => o.msg).filter(Boolean).join(' — ')
    : ''
  if (fromObservaciones) return fromObservaciones
  return invoice.error?.message || null
}
